import { CsvContent } from '@screens/ReportCreation/components/CsvImport/types/csvParser.types';
import Papa from 'papaparse';
import { CSV_DELIMITER } from '@screens/ReportCreation/components/CsvImport/constants/csvParser.constants';

export const normalizeValue = (value?: string): string => (value ?? '').trim();

export const parseCsvContent = <T extends Record<string, string>>(
  content: string,
): CsvContent<T> => {
  const parsedCsv = Papa.parse<T>(content, {
    delimiter: CSV_DELIMITER,
    header: true,
  });

  return {
    headers: parsedCsv.meta.fields as (keyof T & string)[] | undefined,
    content: parsedCsv.data,
  };
};

export const objectIsEmpty = (obj: Record<string, unknown>) =>
  !Object.keys(obj).some((key) => obj[key]);
